'use strict';

exports.__esModule = true;

var _ramda = /*#__PURE__*/require('ramda');

var _isFunction = /*#__PURE__*/require('../isFunction');

var _isFunction2 = /*#__PURE__*/_interopRequireDefault(_isFunction);

var _mapping = /*#__PURE__*/require('../fantasy-land/mapping');

var _mapping2 = /*#__PURE__*/_interopRequireDefault(_mapping);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isFunctor = /*#__PURE__*/(0, _ramda.either)( /*#__PURE__*/(0, _ramda.pathSatisfies)(_isFunction2.default, ['map']), /*#__PURE__*/(0, _ramda.pathSatisfies)(_isFunction2.default, [_mapping2.default.map]));
var isApply = /*#__PURE__*/(0, _ramda.both)(isFunctor, /*#__PURE__*/(0, _ramda.either)( /*#__PURE__*/(0, _ramda.pathSatisfies)(_isFunction2.default, ['ap']), /*#__PURE__*/(0, _ramda.pathSatisfies)(_isFunction2.default, [_mapping2.default.ap])));

var ap = /*#__PURE__*/(0, _ramda.curryN)(2, function (applyF, applyX) {
  // return original ramda `ap` if not Apply spec
  if (!isApply(applyF) || !isApply(applyX)) {
    return (0, _ramda.ap)(applyF, applyX);
  }

  try {
    // new version of `ap` starting from ramda version > 0.23.0
    return applyF.ap(applyX);
  } catch (e) {
    // old version of `ap` till ramda version <= 0.23.0
    return applyX.ap(applyF);
  }
});

exports.default = ap;


//////////////////
// WEBPACK FOOTER
// ./~/ramda-adjunct/lib/internal/ap.js
// module id = 874
// module chunks = 168707334958949